﻿/*!
 * jQuery.parseJSON() extension (supports ISO & Asp.net date conversion)
 *
 * Version 1.0 (13 Jan 2011)
 *
 * Copyright (c) 2011 Robert Koritnik
 * Licensed under the terms of the MIT license
 * http://www.opensource.org/licenses/mit-license.php
 */
require(["jquery", "moment"], function($, moment) {

    // JSON RegExp
    var rvalidtokens = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
    var dateISO = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:[.,]\d+)?Z?/i;
    var dateNet = /\/Date\((\d+)(?:-\d+)?\)\//i;

    // replacer RegExp
    var replaceISO = /"(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:[.,](\d+))?Z?"/i;
    var replaceNet = /"\\\/Date\((\d+)(?:-\d+)?\)\\\/"/i;

    var jsonDateConverter = function(key, value) {
        if (typeof(value) === "string") {
            if (dateISO.test(value)) {
                if (value == '0001-01-01T00:00:00') {
                    return null;
                }

                return moment(value, "YYYY-MM-DDTHH:mm:ssZ").toDate();
            }
            if (dateNet.test(value)) {
                return new Date(parseInt(dateNet.exec(value)[1], 10));
            }
        }
        return value;
    };

    $.extend({
        parseJSONWithDates: function(data) {
            if (!data.length)
                return "";

            // Attempt to parse using the native JSON parser first
            if (window.JSON && window.JSON.parse) {
                // Support: Android 2.3
                // Workaround failure to string-cast null input
                return window.JSON.parse(data + "", jsonDateConverter);
            }

            var requireNonComma,
                depth = null,
                str = jQuery.trim(data + "");

            // Guard against invalid (and possibly dangerous) input by ensuring that nothing remains
            // after removing valid tokens
            return str && !jQuery.trim(str.replace(rvalidtokens, function(token, comma, open, close) {

                    // Force termination if we see a misplaced comma
                    if (requireNonComma && comma) {
                        depth = 0;
                    }

                    // Perform no more replacements after returning to outermost depth
                    if (depth === 0) {
                        return token;
                    }

                    // Commas must not follow "[", "{", or ","
                    requireNonComma = open || comma;

                    // Determine new depth
                    // array/object open ("[" or "{"): depth += true - false (increment)
                    // array/object close ("]" or "}"): depth += false - true (decrement)
                    // other cases ("," or primitive): depth += true - true (numeric cast)
                    depth += !close - !open;

                    // Remove this token
                    return "";
                })) ?
                (Function("return " + str.replace(replaceISO, "new Date(parseInt('$1',10),parseInt('$2',10)-1,parseInt('$3',10),parseInt('$4',10),parseInt('$5',10),parseInt('$6',10),(function(s){return parseInt(s,10)||0;})('$7'))")
                    .replace(replaceNet, "new Date($1)")))() :
                jQuery.error("Invalid JSON: " + data);
        }
    });
});